// extracted by mini-css-extract-plugin
export default {"card":"SupportCard_card__Xq403","box":"SupportCard_box__PfKRA","content":"SupportCard_content__pjYc-"};